import { useState } from "react";
import { Facebook, Twitter, Instagram, Discord } from "../common/Icons";

const Footer = () => {
  const [email, setEmail] = useState("");
  
  return (
    <footer className="py-12 md:py-16 bg-gradient-to-b from-purple-950/50 to-black border-t border-purple-800/50" data-testid="footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xl md:text-2xl font-black text-pink-400 mb-3 md:mb-4">NIRVANA TCG</h3>
            <p className="text-gray-400 text-xs md:text-sm">NirvanaTCG es una comunidad vibrante dedicada a Yu-Gi-Oh!</p>
            <div className="flex gap-2 md:gap-3 mt-4 md:mt-6">
              {[Facebook, Twitter, Instagram, Discord].map((Icon, i) => (
                <a key={i} href="#" className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-pink-500 to-red-500 flex items-center justify-center text-white hover:scale-110 transition-transform">
                  <Icon />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-base md:text-lg font-bold text-yellow-400 mb-3 md:mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-1.5 md:space-y-2">
              {["MarketPlace", "Comunidad", "Torneos", "Contacto"].map((l, i) => (
                <li key={i}><a href="#" className="text-gray-400 hover:text-yellow-400 text-xs md:text-sm">{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-base md:text-lg font-bold text-yellow-400 mb-3 md:mb-4">Servicio al Cliente</h4>
            <ul className="space-y-1.5 md:space-y-2">
              {["Envío", "Devoluciones", "FAQ", "Soporte"].map((l, i) => (
                <li key={i}><a href="#" className="text-gray-400 hover:text-yellow-400 text-xs md:text-sm">{l}</a></li>
              ))}
            </ul>
          </div>
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-base md:text-lg font-bold text-yellow-400 mb-3 md:mb-4">Boletín</h4>
            <p className="text-gray-400 text-xs md:text-sm mb-3 md:mb-4">Mantente actualizado.</p>
            <form onSubmit={(e) => { e.preventDefault(); setEmail(''); }} className="flex gap-2">
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                placeholder="Tu correo" 
                className="flex-1 px-3 md:px-4 py-2 md:py-3 bg-purple-900/50 border border-purple-700 rounded-full text-white text-xs md:text-sm placeholder:text-gray-500 focus:outline-none focus:border-pink-500" 
              />
              <button type="submit" className="px-4 md:px-6 py-2 md:py-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-full text-white font-bold text-xs md:text-sm">OK</button>
            </form>
          </div>
        </div>
        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-purple-800/50 text-center">
          <p className="text-gray-500 text-xs md:text-sm">© 2025 Nirvana TCG. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
